import React, { useMemo } from 'react';
import GlobalMain from '../molecules/Main/GlobalMain';
import { PageProps } from 'gatsby';
import Feed from '../sections/Homepage/Feed/Feed';
import HeroBanner from '../sections/Homepage/HeroBanner/HeroBanner';
import TestimonialsFeed from '../sections/Homepage/TestimonialsFeed/TestimonialsFeed';
import Calculator from '../sections/Homepage/Calculator/Calculator';
import EmpifyTestimonial from '../sections/Homepage/EmpifyTestimonial/EmpifyTestimonial';
import CategoryPiratesTestimonial from '../sections/Homepage/CategoryPiratesTestimonial/CategoryPiratesTestimonial';
import FeaturesCall from '../sections/Homepage/FeaturesCall/FeaturesCall';
import Pricing from '../sections/Homepage/Pricing/Pricing';
import FeaturesList from '../sections/Homepage/FeaturesList/FeaturesList';
import Integrations from '../sections/Homepage/Integrations/Integrations';
import GetToKnowUsBetter from '../sections/Homepage/GetToKnowUsBetter/GetToKnowUsBetter';
import SocialProof from '../sections/Homepage/SocialProof/SocialProof';
import CallToAction from '../sections/Homepage/CallToAction/CallToAction';
import TrustedLogos from '../sections/Homepage/TrustedLogos/TrustedLogos';
import BrandedApp from '../sections/Homepage/BrandedApp/BrandedApp';
import getQueryParams from 'src/functions/getQueryParams';
import { TopInfoBarControllerProviderProps } from 'src/hooks/useTopInfoBarController';
import { useI18nContext } from 'src/hooks/useI18nContext';

const HomepageView = (props: PageProps): JSX.Element => {
  const { language } = useI18nContext();

  const infoBarProps = useMemo<Omit<TopInfoBarControllerProviderProps, 'children'> | false | undefined>(() => {
    // Special case: inactive network query param takes precedence
    if (getQueryParams()['inactive_network'] === '1') {
      return {
        visible: true,
        dismissible: true,
        contentLayout: 'inactiveNetworks',
      };
    }

    // Homepage InfoBar logic based on language
    if (language === 'en') {
      // English users see PeopleMagic banner
      return {
        visible: true,
        dismissible: true,
        contentLayout: 'peopleMagicProfitAnnouncement',
        dismissKey: 'dismissedPeopleMagicProfitAnnouncement_1',
      };
    }

    // Non-English users see Localization banner (use default)
    return undefined;
  }, [language]);

  return (
    <GlobalMain
      location={props.location}
      infoBarProps={infoBarProps}
    >
      <HeroBanner />
      <Feed />
      <Calculator />
      <FeaturesCall />
      <FeaturesList />
      <TestimonialsFeed />
      <EmpifyTestimonial />
      <TrustedLogos />
      <Integrations />
      <Pricing />
      <BrandedApp />
      <CategoryPiratesTestimonial />
      <GetToKnowUsBetter />
      <SocialProof />
      <CallToAction />
    </GlobalMain>
  );
};

export default HomepageView;
